import React from 'react';
import PropTypes from 'prop-types';

import BulletedList from '../bulleted-list/bulleted-list';

import {
  repeatable,
  stringInputSpec,
  stringSelectSpec,
  anchorIdInput,
} from '../../lib/editing-configs';

const EditableBulletedList = ({
  anchorId,
  bullets,
  header,
  isModule,
  type,
}) => (
  <BulletedList
    anchorId={anchorId}
    bullets={bullets.map(({ text }) => text)}
    copyStyle="text-default"
    header={header}
    isModule={isModule}
    parseLinks
    type={type}
  />
);

EditableBulletedList.propTypes = {
  anchorId: PropTypes.string,
  bullets: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
    })
  ).isRequired,
  header: PropTypes.string,
  isModule: PropTypes.bool,
  type: PropTypes.oneOf(['default', 'check', 'none']),
};

EditableBulletedList.defaultProps = {
  bullets: [],
  isModule: true,
};

EditableBulletedList.getEditingConfig = () => [
  stringInputSpec('header', 'Header'),
  repeatable('bullets', 'Bullets', 'Bullet', () => [
    stringInputSpec('text', 'Text'),
  ]),
  stringSelectSpec('type', 'Bullet Type', [
    {
      value: 'default',
      label: 'Default',
    },
    {
      value: 'check',
      label: 'Checkmark',
    },
    {
      value: 'none',
      label: 'None',
    },
  ]),
  anchorIdInput,
];

EditableBulletedList.displayName = 'EditableBulletedList';

export default EditableBulletedList;
